/**
 * Componente para cor de fundo
 * Posicionamento absoluto com z-index baixo
 */
export default function BackgroundColor({ color = '#55b4be', style = {}, ...props }) {
  return (
    <div
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: color,
        zIndex: 0,
        ...style
      }}
      {...props}
    />
  );
}
